<template>
  <div class="iframe">
    <iframe
      id="api"
      :src="url"
      frameborder="0"
      scrolling="auto"
    >
    </iframe>
  </div>
</template>

<script>
import utils from "../common/utils";
import $ from "jquery";

export default {
  data() {
    return { url: "https://cloud.doo3d.com/api/" };
  },
  mounted() {
  },
};
</script>

<style scoped>
.iframe {
  position: absolute;
  width: 100%;
  top: 60px;
  bottom: 32px;
}

#api {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
